var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-nav"},_vm._l((_vm.items),function(item,index){return _c('div',{key:item.text,class:{ line: index === _vm.selectedItem },attrs:{"id":"tab"},on:{"click":function($event){return _vm.selectHandle(index)}}},[_vm._v(" "+_vm._s(item.text)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }